import { render, staticRenderFns } from "./ViewMedicationForm.vue?vue&type=template&id=0b5d5e57&scoped=true"
import script from "./ViewMedicationForm.vue?vue&type=script&lang=js"
export * from "./ViewMedicationForm.vue?vue&type=script&lang=js"
import style0 from "./ViewMedicationForm.vue?vue&type=style&index=0&id=0b5d5e57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d5e57",
  null
  
)

export default component.exports